<template>
  <q-form ref='form'>
    <q-input v-model='customer_name'
             hide-bottom-space
             bg-color="grey-2"
             outlined
             rounded
             class='q-mb-md'
             label='Customer Name'
    />

    <q-input v-model='customer_phone'
             hide-bottom-space
             type='tel'
             bg-color="grey-2"
             outlined
             rounded
             class='q-mb-md'
             label='Customer Phone'
    />

    <q-input v-model='customer_email'
             hide-bottom-space
             type='textarea'
             bg-color="grey-2"
             outlined
             rounded
             label='Customer Email. You can enter multiple separating with , or ; '
    />

    <div class='q-my-md'>
      <strong>Email quote:</strong>
    </div>

    <div class='q-my-sm'>
      <q-toggle v-model='toMe' label='To me' />
    </div>
    <div class='q-my-sm'>
      <q-toggle v-model='toCustomer' label='To customer' />
    </div>

    <q-btn color="primary" label="Send" @click="send" />
  </q-form>
</template>

<script>
export default {
  props: {
    quote: {
      type: Object,
      required: true
    }
  },

  name: 'QuoteEmail',

  emits: [
    // REQUIRED
    'ok', 'hide'
  ],

  data(){
    return {
      customer_name: "",
      customer_phone: "",
      customer_email: "",
      toMe: true,
      toDealer: true,
      toCustomer: true,
    }
  },

  mounted() {
    this.customer_name = this.quote.customer_name
    this.customer_email = this.quote.customer_email
    this.customer_phone = this.quote.customer_phone
  },

  methods: {
    async send() {
      this.axiosPost('/quotes/send', {
        id: this.quote.id,
        to_me: this.toMe,
        to_customer: this.toCustomer,
        customer_phone: this.customer_phone,
        customer_email: this.customer_email,
        customer_name: this.customer_name,
      }, (r) => {
        this.notify('Email sent!')
      })
    },
    // following method is REQUIRED
    // (don't change its name --> "show")
    show () {
      this.$refs.dialog.show()
    },

    // following method is REQUIRED
    // (don't change its name --> "hide")
    hide () {
      this.$refs.dialog.hide()
    },

    onDialogHide () {
      // required to be emitted
      // when QDialog emits "hide" event
      this.$emit('hide')
    },

    onOKClick () {
      // on OK, it is REQUIRED to
      // emit "ok" event (with optional payload)
      // before hiding the QDialog
      this.$emit('ok')
      // or with payload: this.$emit('ok', { ... })

      // then hiding dialog
      this.hide()
    },

    onCancelClick () {
      // we just need to hide the dialog
      this.hide()
    }
  }
}
</script>
